import Stream from '../libs/Stream';


let createOrderItemActionStream: Stream<any> = new Stream() as Stream<any>;

export default createOrderItemActionStream;
